import { useState, useRef, useEffect } from "react";
import Notebook from "../Notes/Notebook";
import LeftPanelContent from "./LeftPane/LeftPanelContent";



const MOBILE_BREAKPOINT = 768;

export default function TestScreen({
  question,
  onhandleSubmit,
  color_left = "#ffffff",
  color_right = "#ffffff",
}) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);
  const mcqValue = useRef(null);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const onClick = (item) => {
    const hasMcq = item.res?.mcq != null;
    mcqValue.current = hasMcq ? `Option ${item.res.mcq}` : "";
  };

  const onSubmit = (blocks) => {
    let answer = blocks[0].content + " " + blocks[1].content;
    if (mcqValue.current) answer += " " + mcqValue.current;
    onhandleSubmit(answer);
  };

  if (isMobile) {
    return (
      <div style={{ width: "100vw", height: "100vh", overflowY: "auto" }}>
        <div style={{ background: color_left }}>
          <LeftPanelContent question={question} onClick={onClick} panelWidth={window.innerWidth} />
        </div>
        <div
          style={{ width: "100%", background: color_right }}  // ← was "50%", also remove height/overflow
          onPaste={(e) => e.preventDefault()}
          onCopy={(e) => e.preventDefault()}
          onCut={(e) => e.preventDefault()}
          onContextMenu={(e) => e.preventDefault()}
        >
          <Notebook onSubmit={onSubmit} timerSeconds={question.time} />
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", width: "100vw", height: "100vh", overflow: "hidden" }}>
      <div style={{ width: "50%", height: "100%", background: color_left, overflow: "auto" }}>
        <LeftPanelContent question={question} onClick={onClick} panelWidth={window.innerWidth * 0.5} />
      </div>

      <div style={{ width: "2px", background: "#e0e0e0", flexShrink: 0 }} />
      <div
        style={{ width: "50%", height: "100%", background: color_right, overflow: "hidden" }}
        onPaste={(e) => e.preventDefault()}
        onCopy={(e) => e.preventDefault()}
        onCut={(e) => e.preventDefault()}
        onContextMenu={(e) => e.preventDefault()}
      >
        <Notebook onSubmit={onSubmit} timerSeconds={question.time} />
      </div>
    </div>
  );
}